import styled from 'styled-components'


import {
  FacebookSquare,
  InstagramAlt,
  LinkedinSquare,
  Spotify,
  Twitter,
  Youtube
} from '@styled-icons/boxicons-logos'
import { Medium } from '@styled-icons/simple-icons/Medium'

// ICONS

export const FacebookIcon = styled(FacebookSquare)`
  width: 26px;
`
export const TwitterIcon = styled(Twitter)`
  width: 26px;
`
export const YoutubeIcon = styled(Youtube)`
  width: 26px;
`
export const LinkedinIcon = styled(LinkedinSquare)`
  width: 26px;
`
export const MediumIcon = styled(Medium)`
  width: 26px;
`
export const SpotifyIcon = styled(Spotify)`
  width: 26px;
`
export const InstagramIcon = styled(InstagramAlt)`
  width: 26px;
`

export const SocialIconsWrapper = styled.aside`
  ul {
    display: flex;
    flex-wrap: wrap;
  }

  li {
    cursor: pointer;
    padding: 5px;
    margin-left: -5px;

    :not(:last-child) {
      margin-right: 27px;
    }

    svg {
      color: var(--orange);
      transition: all 0.2s;

      :hover {
        color: #fff;
      }
    }
  }

  @media (max-width: 768px) {
    ul {
      flex-wrap: wrap;
      margin-left: -16px;
    }

    li {
      :not(:last-child),
      :last-child {
        margin-right: 0;
        margin-left: 16px;
        margin-bottom: 8px;
      }
    }
  }
`
